import React, { useEffect, useState, useRef } from "react";
import { Spinner } from 'reactstrap'

import { Button, Checkbox, DefaultInput, DefaultSelect, ToggleButton } from "ui-kit-takeat";
import AsyncSelect from "components/Form/AsyncSelectInput";

import { FaTrashAlt, FaCheck, FaCopy } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import { Content, CheckBoxArea, InputsArea } from './styles';
import { SwitchArea } from "../EditArea/styles";

import apiGd from "services/apiGd";
import { getBrands } from "services/brandsService";

const OPEN_DELIVERY_WEBHOOK_URL = "https://webhook.takeat.app/public/open-delivery/v1/newEvent";

function async_debounce(fn, delay_ms, ref) {
  return new Promise((resolve, reject) => {
    const timeout_id = setTimeout(async () => {
      if (ref.current === timeout_id) {
        const result = await fn();
        resolve(result);
      } else {
        reject();
      }
    }, delay_ms);

    ref.current = timeout_id;
  });
}

function EditPayments({
  tableLimitTypeDefault,
  setTableLimitType,
  setIsTableLimitDisabled,
  setTableLimitTypeDefault,
  tableLimitValue,
  isTableLimitDisabled,
  notify,
  restaurantData,
  setRestaurantData,
  updateProfile,
  id,
  token,
  ifoodRestaurants,
  setIfoodRestaurants,
  setTableLimitValue,

  // Paytime
  establishmentId,
  setEstablishmentId,
}) {
  const [paytimeEstablishments, setPaytimeEstablishments] = useState([]);

  const [posTableActive, setPosTableActive] = useState(false);
  const [loadingPosTableActive, setLoadingPosTableActive] = useState(false);
  const [usingPaytime, setUsingPaytime] = useState(false);

  useEffect(() => {
    setUsingPaytime(establishmentId !== null);
  }, [establishmentId]);

  useEffect(() => {
    setPosTableActive(restaurantData ?.settings ?.pos_table_active);
  }, [restaurantData ?.settings ?.pos_table_active]);

  const handleChange = (field, value) => {
    setRestaurantData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  useEffect(() => {
    const pickngoRestaurant = ifoodRestaurants ?.find(
      (item) => item.integration_code === 8
    );

    if (pickngoRestaurant) {
      setInfoPicKnGo({
        client_id: pickngoRestaurant.ifood_merchant_id || '',
        client_secret: pickngoRestaurant.secret || '',
      });
    }
  }, [ifoodRestaurants]);

  const [infoIfood, setInfoIfood] = useState({
    merchant_id: '',
    name: '',
    brand_id: null,
  });
  const [infoKeeta, setInfoKeeta] = useState({
    keeta_merchant_id: '',
    name: '',
    brand_id: null,
  });

  const [info99Food, setInfo99Food] = useState({
    shop_id: '',
    name: '',
    brand_id: null,
  });
  const [infoCardapioWeb, setInfoCardapioWeb] = useState({
    client_id: '',
    secret: '',
    name: '',
    brand_id: null,
  });
  const [infoWabiz, setInfoWabiz] = useState({
    shop_id: '',
    name: '',
    secret: '',
    brand_id: null,
  });
  const [infoPicKnGo, setInfoPicKnGo] = useState({
    client_id: '',
    client_secret: ''
  })
  const [infoAgilizone, setInfoAgilizone] = useState({
    client_id: '',
    client_secret: ''
  })

  const [brands, setBrands] = useState([]);

  useEffect(() => {
    if (!id) return;

    getBrands(id, token)
      .then((data) => setBrands(Array.isArray(data) ? data : []))
      .catch(() => setBrands([]));
  }, [id, token]);

  const brandOptions = brands.map((brand) => ({
    value: brand.id,
    label: brand.fantasy_name || brand.name,
  }));

  const findBrandOption = (brandId) =>
    brandOptions.find((option) => option.value === brandId) || null;

  const findBrandName = (brandId) => {
    const brand = brands.find((item) => item.id === brandId);
    return brand ? brand.fantasy_name || brand.name : null;
  };

  const handleAddIfoodId = async () => {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    if (infoIfood.merchant_id === "" || infoIfood.name === "") {
      notify("tr", "danger", "Preencha nome e merchant id do ifood");
    } else {
      try {
        const data = {
          restaurant_id: id,
          name: infoIfood.name,
          merchant_id: infoIfood.merchant_id,
          brand_id: infoIfood.brand_id,
        };
        const response = await apiGd.post(
          `admin/restaurants/ifood/merchant`,
          data,
          reqConfig
        );
        setInfoIfood({ name: "", merchant_id: "", brand_id: null })
        setIfoodRestaurants((state) => [...state, response.data]);
        notify("tr", "success", "Inserido com sucesso");
      } catch (err) {
        notify("tr", "danger", err ?.response ?.data ?.error || "Erro ao inserir.");
      }
    }
  };

  async function handleKeetaAdd() {
    try {
      console.log(id)
      const data = {
        restaurantId: id,
        keetaMerchantId: infoKeeta.keeta_merchant_id,
        name: infoKeeta.name,
        brand_id: infoKeeta.brand_id,
      };
      const response = await apiGd.post(
        `public/keeta/associate`,
        data,
      );
      setInfoKeeta({ keeta_merchant_id: "", name: "", brand_id: null })
      setIfoodRestaurants((state) => [...state, response.data]);
      notify("tr", "success", "Inserido com sucesso");
    } catch (err) {
      notify("tr", "danger", err ?.response ?.data ?.error || "Erro ao inserir.");
    }
  };

  async function handleDeleteKeeta(ifood_merchant_id) {
    try {
      // A desautorização deve ocorrer antes de setar canceled_at (soft delete).
      // Se ela falhar, o delete abaixo não é executado e o registro segue ativo.
      await apiGd.post('public/keeta/delete-store', {
        shopId: ifood_merchant_id,
      });

      await apiGd.delete('admin/open-delivery/merchants', {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          restaurant_id: id,
          ifood_merchant_id,
        },
      });

      setIfoodRestaurants((state) =>
        state.filter((rest) => rest.ifood_merchant_id !== ifood_merchant_id)
      );

      notify("tr", "success", "Removido com sucesso");
    } catch (err) {
      notify("tr", "danger", "Erro ao remover.");
    }
  }

  const handlePicKnGoAdd = async () => {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const data = {
        restaurantId: id,
        client_id: infoPicKnGo.client_id,
        client_secret: infoPicKnGo.client_secret
      };
      const response = await apiGd.post(
        `/admin/pickngo/add-restaurant`,
        data,
        reqConfig
      );
      setIfoodRestaurants((state) => [...state, response.data]);
      setInfoPicKnGo({ client_id: "", client_secret: "" })
      notify("tr", "success", "Inserido com sucesso");
    } catch (err) {
      notify("tr", "danger", err ?.response ?.data ?.error || "Erro ao inserir.");
    }
  };

  const handleAgilizoneAdd = async () => {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const data = {
        restaurantId: id,
        client_id: infoAgilizone.client_id,
        client_secret: infoAgilizone.client_secret
      };
      const response = await apiGd.post(
        `/admin/restaurants/agilizone/add-restaurant`,
        data,
        reqConfig
      );
      setIfoodRestaurants((state) => [...state, response.data]);
      setInfoAgilizone({ client_id: "", client_secret: "" })
      notify("tr", "success", "Inserido com sucesso");
    } catch (err) {
      notify("tr", "danger", err ?.response ?.data ?.error || "Erro ao inserir.");
    }
  };

  const LOGISTICS_LABELS = {
    use_pickngo: "PicKnGo",
    use_agilizone: "Agilizone",
    use_foody_delivery: "Foody Delivery",
  };

  const logisticOptions = [
    { value: "none", label: "Nenhuma" },
    { value: "use_agilizone", label: "Agilizone" },
    { value: "use_foody_delivery", label: "Foody Delivery" },
    { value: "use_pickngo", label: "PicKnGo" },
  ];

  const activeLogisticKeys = Object.keys(LOGISTICS_LABELS).filter(
    (k) => restaurantData?.settings?.[k]
  );
  const hasLogisticConflict = activeLogisticKeys.length > 1;
  const selectedLogistic = hasLogisticConflict
    ? logisticOptions[0]
    : logisticOptions.find((o) => o.value === activeLogisticKeys[0]) ||
      logisticOptions[0];

  function handleSelectLogistic(value) {
    setRestaurantData((prevData) => ({
      ...prevData,
      settings: {
        ...prevData.settings,
        use_agilizone: value === "use_agilizone",
        use_foody_delivery: value === "use_foody_delivery",
        use_pickngo: value === "use_pickngo",
      },
    }));
  }

  const handleDeleteIfoodId = async (ifood_merchant_id) => {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        restaurant_id: id,
        merchant_id: ifood_merchant_id,
      },
    };

    try {
      await apiGd.delete(`admin/restaurants/ifood/merchant`, reqConfig);
      setIfoodRestaurants((state) =>
        state.filter((rest) => rest.ifood_merchant_id !== ifood_merchant_id)
      );
      notify("tr", "success", "Deletado com sucesso");
    } catch (err) {
      notify("tr", "danger", "Erro ao remover.");
    }
  };

  async function handleAdd99Food() {
    try {
      const data = {
        ...info99Food,
        restaurant_id: id,
      };

      const response = await apiGd.post(
        'admin/restaurants/99food/merchant',
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setInfo99Food({ shop_id: '', name: '', brand_id: null })
      setIfoodRestaurants((state) => [...state, response.data]);

      notify("tr", "success", "Inserido com sucesso");
    } catch (err) {
      notify("tr", "danger", "Erro ao inserir.");
    }
  }

  async function handleAddCardapioWeb() {
    try {
      const data = {
        restaurant_id: id,
        integration: 'CardapioWeb',
        ifood_merchant_id: infoCardapioWeb.client_id,
        secret: infoCardapioWeb.secret,
        name: infoCardapioWeb.name,
        brand_id: infoCardapioWeb.brand_id,
      };

      const response = await apiGd.post('admin/open-delivery/merchants', data, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setInfoCardapioWeb({ client_id: '', secret: '', name: '', brand_id: null })
      setIfoodRestaurants((state) => [...state, response.data]);

      notify("tr", "success", "Inserido com sucesso");
    } catch (err) {
      notify("tr", "danger", err?.response?.data?.error || "Erro ao inserir.");
    }
  }

  async function handleDeleteCardapioWeb(ifood_merchant_id) {
    try {
      await apiGd.delete('admin/open-delivery/merchants', {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          restaurant_id: id,
          ifood_merchant_id,
        },
      });

      setIfoodRestaurants((state) =>
        state.filter((rest) => rest.ifood_merchant_id !== ifood_merchant_id)
      );

      notify("tr", "success", "Removido com sucesso");
    } catch (err) {
      notify("tr", "danger", "Erro ao remover.");
    }
  }

  function handleCopyCardapioWebWebhook() {
    navigator.clipboard.writeText(OPEN_DELIVERY_WEBHOOK_URL);
    notify("tr", "success", "Webhook copiado");
  }

  async function handleDelete99Food(shop_id) {
    try {
      await apiGd.delete(
        `admin/restaurants/99food/merchant`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            restaurant_id: id,
            shop_id,
          },
        }
      );

      setIfoodRestaurants((state) =>
        state.filter((rest) => rest.shop_id !== shop_id)
      );

      notify("tr", "success", "Removido com sucesso");
    } catch (err) {
      notify("tr", "danger", "Erro ao remover.");
    }
  }

  async function handleAddWabiz() {
    try {
      const data = {
        ...infoWabiz,
        restaurant_id: id,
      };

      const response = await apiGd.post(
        'admin/restaurants/wabiz/merchant',
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setInfoWabiz({ shop_id: '', secret: '', name: '', brand_id: null })
      setIfoodRestaurants((state) => [...state, response.data]);

      notify("tr", "success", "Inserido com sucesso");
    } catch (err) {
      notify("tr", "danger", "Erro ao inserir.");
    }
  }

  async function handleDeleteWabiz(shop_id) {
    try {
      await apiGd.delete(
        `admin/restaurants/wabiz/merchant`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            restaurant_id: id,
            shop_id,
          },
        }
      );

      setIfoodRestaurants((state) =>
        state.filter((rest) => rest.shop_id !== shop_id)
      );

      notify("tr", "success", "Removido com sucesso");
    } catch (err) {
      notify("tr", "danger", "Erro ao remover.");
    }
  }

  const handleChangePosTable = async () => {
    setLoadingPosTableActive(true);
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const data = {
        pos_table_active: !posTableActive
      };

      const response = await apiGd.put(
        `admin/restaurants/table/pos/${id}`,
        data,
        reqConfig
      );

      setPosTableActive(response.data.pos_table_active);
      notify("tr", "success", `Mesa ficha ${response.data.pos_table_active ? 'ativada' : 'desativada'}`);
    } catch (err) {
      notify("tr", "danger", "Erro ao atualizar mesa ficha.");
    }
    setLoadingPosTableActive(false);
  };

  const debounceRef = useRef(0);
  const [loading, setLoading] = useState(false);
  const [showPaytimeSelect, setShowPaytimeSelect] = useState(false);

  async function getPaytimeEstablishments(search = '') {
    if (!showPaytimeSelect) {
      return paytimeEstablishments;
    }

    if (search === '') {
      if (establishmentId) {
        search = establishmentId.toString();
      } else if (restaurantData.cnpj) {
        search = restaurantData.cnpj;
      } else if (paytimeEstablishments.length > 0) {
        return paytimeEstablishments;
      }
    }

    try {
      const response = await apiGd.get(
        `/admin/paytime/establishments?search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.map((m) => {
        return {
          label: `${m.first_name} | ${m.last_name || ''} | ${m.document}`,
          value: m.id,
        };
      }).sort((a, b) => a.label.localeCompare(b.label));

      await new Promise((r) => setTimeout(r, 2000));
      setPaytimeEstablishments(options);

      return options;
    } catch (error) {
      console.log('paytime search error', error);

      const result = [];
      setPaytimeEstablishments(result);

      return result;
    }
  }

  function togglePaytimeSelect() {
    setShowPaytimeSelect((v) => !v);
  }

  useEffect(() => {
    async function doit() {
      if (showPaytimeSelect) {
        setLoading(true);
        await getPaytimeEstablishments('', () => { });
        setLoading(false);
      }
    }

    doit();
  }, [showPaytimeSelect]);

  const tableOptions = [
    { value: "only-balcony", label: "Somente balcão" },
    { value: "limited-tables-10", label: "Limite de 10 mesas" },
    { value: "limited-tables-30", label: "Limite de 30 mesas" },
    { value: "limited-tables", label: "Limitar mesas" },
    { value: "unlimited-tables", label: "Mesas ilimitadas" },
  ];

  return (
    <Content>
      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Pagamento online</span>
        <Checkbox
          label="Pix online"
          checked={restaurantData ?.has_pix}
          onClick={(e) => handleChange('has_pix', e)}
        />
        <Checkbox
          label="Cartão de credito online"
          checked={restaurantData ?.has_credit_card}
          onClick={(e) => handleChange('has_credit_card', e)}
        />

        {(restaurantData ?.has_pix || restaurantData ?.has_credit_card) && (
          <DefaultInput
            placeholder="Token Zoop"
            type="text"
            value={restaurantData ?.paytime_seller_id}
            onChange={(e) => handleChange('paytime_seller_id', e.target.value)}
          />
        )}

        <Checkbox
          label="Pagamentos via Paytime"
          checked={usingPaytime}
          onClick={() => {
            setUsingPaytime((e) => !e);
            setEstablishmentId(null);
          }}
        />

        {usingPaytime &&
          <details
            style={{ margin: '0px 25px' }}
            onToggle={togglePaytimeSelect}
          >
            <summary> Alterar estabelecimento da Paytime </summary>

            {loading
              ? <Spinner />
              : <AsyncSelect
                name="select_establishments"
                placeholder="Selecione ou pesquise"
                cacheOptions
                defaultOptions={paytimeEstablishments}
                loadOptions={(search) => {
                  return async_debounce(
                    () => getPaytimeEstablishments(search),
                    150,
                    debounceRef
                  );
                }}
                value={
                  establishmentId && paytimeEstablishments.find(
                    (e) => e.value === establishmentId
                  )
                }
                onChange={(e) => setEstablishmentId(e.value)}
                controlStyles={{ height: 48 }}
              />
            }
          </details>
        }

      </CheckBoxArea>

      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Cardápio digital</span>
        <Checkbox
          label="Habilitar pedidos via QR code"
          checked={!restaurantData ?.only_qrcode}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              ["only_qrcode"]: !e,
            }));
          }}
        />
        <Checkbox
          label="Habilitar balcão"
          checked={restaurantData ?.settings.has_balcony}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["has_balcony"]: e,
              }
            }));
          }}
        />
      </CheckBoxArea>

      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Delivery</span>
        <Checkbox
          label="Apenas delivery"
          checked={restaurantData ?.only_delivery}
          onClick={(e) => handleChange('only_delivery', e)}
        />
        <Checkbox
          label="Habilitar delivery e retirada"
          checked={restaurantData ?.delivery_info.is_delivery_allowed}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              delivery_info: {
                ...prevData.delivery_info,
                ["is_delivery_allowed"]: e,
              }
            }))
          }}
        />
        <Checkbox
          label="Habilitar o cadastro dos endereços de entrega"
          checked={restaurantData ?.delivery_info.allow_delivery_addresses}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              delivery_info: {
                ...prevData.delivery_info,
                ["allow_delivery_addresses"]: e,
              }
            }))
          }}
        />
        <Checkbox
          label="Usar todas as colunas do kanban de delivery"
          checked={restaurantData ?.delivery_info.use_all_kanbans}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              delivery_info: {
                ...prevData.delivery_info,
                ["use_all_kanbans"]: e,
              }
            }))
          }}
        />
      </CheckBoxArea>

      <CheckBoxArea>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Checkbox
            label="Ifood Ativo"
            checked={restaurantData.has_ifood}
            onClick={() => {
              setRestaurantData((old) => ({
                ...old,
                has_ifood: !restaurantData.has_ifood,
              }));
            }}
          />

          {restaurantData.has_ifood && (
            <Checkbox
              label="Integração com Código PDV"
              checked={restaurantData ?.settings.use_ifood_pdv_code}
              onClick={(e) => {
                setRestaurantData(old => {
                  return {
                    ...old,
                    settings: {
                      ...old.settings,
                      use_ifood_pdv_code: e
                    }
                  }
                })
              }}
            />
          )}

          <InputsArea style={{ marginTop: 10 }}>
            {restaurantData.has_ifood && (
              <>
                <DefaultInput
                  placeholder="iFood ID"
                  value={infoIfood.id}
                  onChange={(e) => setInfoIfood({ ...infoIfood, merchant_id: e.target.value })}
                />
                <DefaultInput
                  placeholder="Nome iFood"
                  value={infoIfood.name}
                  onChange={(e) => setInfoIfood({ ...infoIfood, name: e.target.value })}
                />
                <DefaultSelect
                  name="ifood_brand"
                  options={brandOptions}
                  placeholder="Marca"
                  value={findBrandOption(infoIfood.brand_id)}
                  onChange={(e) => setInfoIfood({ ...infoIfood, brand_id: e?.value ?? null })}
                  controlStyles={{ height: 48, minWidth: 180 }}
                />
                <FaPlus
                  color="white"
                  style={{
                    cursor: 'pointer',
                    backgroundColor: '#C8131B',
                    padding: 12,
                    borderRadius: 8,
                    width: 55,
                    height: 40,
                  }}
                  onClick={handleAddIfoodId}
                />
              </>
            )}
          </InputsArea>

          {restaurantData.has_ifood && ifoodRestaurants.length > 0 &&
            ifoodRestaurants
              .filter(item => item.integration_code === 1)
              .map((item) => (
                <div key={item.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 16, fontWeight: 500 }}>
                    {item.ifood_merchant_id}
                  </span>

                  <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    {findBrandName(item.brand_id) && (
                      <span style={{ fontSize: 13, color: '#6c757d' }}>
                        {findBrandName(item.brand_id)}
                      </span>
                    )}

                    <span style={{ fontSize: 16, fontWeight: 600 }}>
                      {item.name}
                    </span>

                    <FaTrashAlt
                      size={15}
                      color="#C8131B"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleDeleteIfoodId(item.ifood_merchant_id)}
                    />
                  </div>
                </div>
              ))
          }

        </div>
      </CheckBoxArea>
      <CheckBoxArea>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <InputsArea style={{ marginTop: 10 }}>
            <>
              <DefaultInput
                placeholder="Keeta ID"
                value={infoKeeta.keeta_merchant_id}
                onChange={(e) => setInfoKeeta({ ...infoKeeta, keeta_merchant_id: e.target.value })}
              />
              <DefaultInput
                placeholder="Nome Keeta"
                value={infoKeeta.name}
                onChange={(e) => setInfoKeeta({ ...infoKeeta, name: e.target.value })}
              />
              <DefaultSelect
                name="keeta_brand"
                options={brandOptions}
                placeholder="Marca"
                value={findBrandOption(infoKeeta.brand_id)}
                onChange={(e) => setInfoKeeta({ ...infoKeeta, brand_id: e?.value ?? null })}
                controlStyles={{ height: 48, minWidth: 180 }}
              />
              <FaPlus
                color="white"
                style={{
                  cursor: 'pointer',
                  backgroundColor: '#C8131B',
                  padding: 12,
                  borderRadius: 8,
                  width: 55,
                  height: 40,
                }}
                onClick={handleKeetaAdd}
              />
            </>
          </InputsArea>
          {ifoodRestaurants
            .filter(item => item.integration_code === 3)
            .map(item => (
              <div
                key={item.id}
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <span style={{ fontSize: 16, fontWeight: 500 }}>
                  {item.ifood_merchant_id}
                </span>

                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                  {findBrandName(item.brand_id) && (
                    <span style={{ fontSize: 13, color: '#6c757d' }}>
                      {findBrandName(item.brand_id)}
                    </span>
                  )}

                  <span style={{ fontSize: 16, fontWeight: 600 }}>
                    {item.name}
                  </span>

                  <span
                    style={{
                      padding: "6px 14px",
                      borderRadius: 12,
                      fontSize: 14,
                      fontWeight: 600,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid rgba(0,0,0,0.1)",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                      backgroundColor: item.active ? "#2BB8A8" : "#C8131B",
                      color: "#fff",
                      minWidth: 80,
                      textAlign: "center",
                      marginTop: 5
                    }}
                  >
                    {item.active ? "Ativo" : "Inativo"}
                  </span>

                  <FaTrashAlt
                    size={15}
                    color="#C8131B"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleDeleteKeeta(item.ifood_merchant_id)}
                  />

                </div>
              </div>
            ))}
        </div>

      </CheckBoxArea>
      <CheckBoxArea>
        <Checkbox
          label="Ativar Cardápio Web"
          checked={restaurantData?.settings?.use_cardapioweb}
          onClick={() => {
            setRestaurantData((old) => ({
              ...old,
              settings: {
                ...old.settings,
                use_cardapioweb: !old?.settings?.use_cardapioweb,
              },
            }));
          }}
        />

        <div style={{ display: "flex", flexDirection: "column" }}>
          <InputsArea style={{ marginTop: 10 }}>
            {restaurantData?.settings?.use_cardapioweb && (
            <>
              <DefaultInput
                placeholder="Client ID"
                value={infoCardapioWeb.client_id}
                onChange={(e) => setInfoCardapioWeb({ ...infoCardapioWeb, client_id: e.target.value })}
              />
              <DefaultInput
                placeholder="Secret"
                value={infoCardapioWeb.secret}
                onChange={(e) => setInfoCardapioWeb({ ...infoCardapioWeb, secret: e.target.value })}
              />
              <DefaultInput
                placeholder="Nome Cardápio Web"
                value={infoCardapioWeb.name}
                onChange={(e) => setInfoCardapioWeb({ ...infoCardapioWeb, name: e.target.value })}
              />
              <DefaultSelect
                name="cardapioweb_brand"
                options={brandOptions}
                placeholder="Marca"
                value={findBrandOption(infoCardapioWeb.brand_id)}
                onChange={(e) => setInfoCardapioWeb({ ...infoCardapioWeb, brand_id: e?.value ?? null })}
                controlStyles={{ height: 48, minWidth: 180 }}
              />
              <FaPlus
                color="white"
                style={{
                  cursor: 'pointer',
                  backgroundColor: '#C8131B',
                  padding: 12,
                  borderRadius: 8,
                  width: 55,
                  height: 40,
                }}
                onClick={handleAddCardapioWeb}
              />
            </>
            )}
          </InputsArea>
          {restaurantData?.settings?.use_cardapioweb && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
              <span style={{ fontSize: 13, color: '#6c757d' }}>Webhook:</span>
              <span style={{ fontSize: 14, fontWeight: 500 }}>
                {OPEN_DELIVERY_WEBHOOK_URL}
              </span>
              <FaCopy
                size={15}
                color="#C8131B"
                style={{ cursor: 'pointer' }}
                onClick={handleCopyCardapioWebWebhook}
              />
            </div>
          )}
          {restaurantData?.settings?.use_cardapioweb &&
            ifoodRestaurants
            .filter(item => item.integration_code === 9)
            .map(item => (
              <div
                key={item.id}
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <span style={{ fontSize: 16, fontWeight: 500 }}>
                  {item.ifood_merchant_id}
                </span>

                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                  {findBrandName(item.brand_id) && (
                    <span style={{ fontSize: 13, color: '#6c757d' }}>
                      {findBrandName(item.brand_id)}
                    </span>
                  )}

                  <span style={{ fontSize: 16, fontWeight: 600 }}>
                    {item.name}
                  </span>

                  <FaTrashAlt
                    size={15}
                    color="#C8131B"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleDeleteCardapioWeb(item.ifood_merchant_id)}
                  />

                </div>
              </div>
            ))}
        </div>

      </CheckBoxArea>
      <CheckBoxArea>
        <Checkbox
          label="Ativar 99Food"
          checked={restaurantData.has_99food}
          onClick={() => {
            setRestaurantData((old) => ({
              ...old,
              has_99food: !restaurantData.has_99food,
            }));
          }}
        />

        <div style={{ display: "flex", flexDirection: "column" }}>
          <InputsArea>
            {restaurantData.has_99food && (
              <>
                <DefaultInput
                  placeholder="ID 99Food"
                  value={info99Food.shop_id}
                  onChange={(e) => {
                    setInfo99Food({ ...info99Food, shop_id: e.target.value });
                  }}
                />
                <DefaultInput
                  placeholder="Nome 99Food"
                  value={info99Food.name}
                  onChange={(e) => {
                    setInfo99Food({ ...info99Food, name: e.target.value });
                  }}
                />
                <DefaultSelect
                  name="99food_brand"
                  options={brandOptions}
                  placeholder="Marca"
                  value={findBrandOption(info99Food.brand_id)}
                  onChange={(e) => setInfo99Food({ ...info99Food, brand_id: e?.value ?? null })}
                  controlStyles={{ height: 48, minWidth: 180 }}
                />
                <FaPlus
                  color="white"
                  style={{
                    cursor: 'pointer',
                    backgroundColor: '#C8131B',
                    padding: 12,
                    borderRadius: 8,
                    width: 55,
                    height: 40,
                  }}
                  onClick={handleAdd99Food}
                />
              </>
            )}
          </InputsArea>

          {restaurantData.has_99food &&
            ifoodRestaurants
              .filter(item => item.integration_code === 4)
              .map((item) => (
                <div
                  key={item.id}
                  style={{
                    display: 'flex',
                    itemsAlign: 'center',
                    gap: '16px',
                    marginTop: '3px',
                    fontSize: 16,
                  }}
                >
                  <span style={{ fontWeight: 500, width: '100%' }}>
                    {item.shop_id}
                  </span>

                  <span style={{ fontWeight: 500, width: '100%', color: '#6c757d' }}>
                    {findBrandName(item.brand_id)}
                  </span>

                  <span style={{ fontWeight: 600, width: '100%' }}>
                    {item.name}
                  </span>

                  <FaTrashAlt
                    color="#C8131B"
                    style={{
                      cursor: 'pointer',
                      padding: 12,
                      width: 55,
                      height: 40,
                    }}
                    onClick={() => handleDelete99Food(item.shop_id)}
                  />
                </div>
              ))
          }

        </div>
      </CheckBoxArea>
      <CheckBoxArea>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <InputsArea>
            <DefaultInput
              placeholder="Email Wabiz"
              value={infoWabiz.shop_id}
              onChange={(e) => {
                setInfoWabiz({ ...infoWabiz, shop_id: e.target.value });
              }}
            />
            <DefaultInput
              placeholder="Senha Wabiz"
              value={infoWabiz.secret}
              onChange={(e) => {
                setInfoWabiz({ ...infoWabiz, secret: e.target.value });
              }}
            />
            <DefaultInput
              placeholder="Nome Loja Wabiz"
              value={infoWabiz.name}
              onChange={(e) => {
                setInfoWabiz({ ...infoWabiz, name: e.target.value });
              }}
            />
            <DefaultSelect
              name="wabiz_brand"
              options={brandOptions}
              placeholder="Marca"
              value={findBrandOption(infoWabiz.brand_id)}
              onChange={(e) => setInfoWabiz({ ...infoWabiz, brand_id: e?.value ?? null })}
              controlStyles={{ height: 48, minWidth: 180 }}
            />
            <FaPlus
              color="white"
              style={{
                cursor: 'pointer',
                backgroundColor: '#C8131B',
                padding: 12,
                borderRadius: 8,
                width: 66,
                height: 40,
              }}
              onClick={handleAddWabiz}
            />
          </InputsArea>

          {ifoodRestaurants
            .filter(item => item.integration_code === 6)
            .map((item) => (
              <div
                key={item.id}
                style={{
                  display: 'flex',
                  itemsAlign: 'center',
                  gap: '16px',
                  marginTop: '3px',
                  fontSize: 16,
                }}
              >
                <span style={{ fontWeight: 500, width: '100%' }}>
                  {item.shop_id}
                </span>

                <span style={{ width: '100%', color: '#6c757d' }}>
                  ••••••
                </span>

                <span style={{ fontWeight: 600, width: '100%' }}>
                  {item.name}
                </span>

                <span style={{ width: '100%', fontWeight: 500, color: '#6c757d' }}>
                  {findBrandName(item.brand_id)}
                </span>

                <FaTrashAlt
                  color="#C8131B"
                  style={{
                    cursor: 'pointer',
                    padding: 12,
                    width: 66,
                    height: 40,
                  }}
                  onClick={() => handleDeleteWabiz(item.shop_id)}
                />
              </div>
            ))
          }
        </div>
      </CheckBoxArea>
      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>
          Integrações de Logística
        </span>
        <span style={{ fontFamily: 'Poppins', fontSize: 12, color: '#6c757d' }}>
          Apenas uma integração de logística pode estar ativa por vez.
        </span>
        {hasLogisticConflict && (
          <div
            style={{
              marginTop: 8,
              padding: '8px 12px',
              borderRadius: 8,
              border: '1px solid #C8131B',
              background: '#FDECEC',
              color: '#C8131B',
              fontFamily: 'Poppins',
              fontSize: 13,
            }}
          >
            Múltiplas logísticas ativas:{' '}
            {activeLogisticKeys.map((k) => LOGISTICS_LABELS[k]).join(', ')}.
            Selecione apenas uma para corrigir antes de salvar.
          </div>
        )}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
          {logisticOptions.map((opt) => {
            const isActive = selectedLogistic.value === opt.value;
            return (
              <button
                key={opt.value}
                type="button"
                onClick={() => handleSelectLogistic(opt.value)}
                style={{
                  fontFamily: 'Poppins',
                  fontSize: 14,
                  fontWeight: 500,
                  padding: '8px 16px',
                  borderRadius: 8,
                  border: `1px solid ${isActive ? '#2EC9B7' : '#ced4da'}`,
                  background: isActive ? '#2EC9B7' : '#fff',
                  color: isActive ? '#fff' : '#495057',
                  cursor: 'pointer',
                  transition: 'all 0.15s ease',
                }}
              >
                {opt.label}
              </button>
            );
          })}
        </div>

        {restaurantData?.settings?.use_agilizone &&
          <InputsArea>
            <DefaultInput
              placeholder="client_id"
              value={infoAgilizone.client_id}
              onChange={(e) => setInfoAgilizone({ ...infoAgilizone, client_id: e.target.value })}
            />
            <DefaultInput
              placeholder="client_secret"
              value={infoAgilizone.client_secret}
              onChange={(e) => setInfoAgilizone({ ...infoAgilizone, client_secret: e.target.value })}
            />
            <FaCheck
              color="white"
              style={{
                cursor: 'pointer',
                backgroundColor: '#C8131B',
                padding: 12,
                borderRadius: 8,
                width: 55,
                height: 40,
              }}
              onClick={handleAgilizoneAdd}
            />
          </InputsArea>
        }

        {restaurantData?.settings?.use_foody_delivery &&
          <InputsArea>
            <DefaultInput
              placeholder="Foody Delivery Token"
              value={restaurantData?.settings?.foody_delivery_token}
              onChange={(e) => setRestaurantData((prevData) => ({
                ...prevData,
                settings: {
                  ...prevData.settings,
                  foody_delivery_token: e.target.value,
                }
              }))}
            />
          </InputsArea>
        }

        {restaurantData?.settings?.use_pickngo &&
          <InputsArea>
            <DefaultInput
              placeholder="Código da empresa"
              value={infoPicKnGo.client_id}
              onChange={(e) => setInfoPicKnGo({ ...infoPicKnGo, client_id: e.target.value })}
            />
            <DefaultInput
              placeholder="Chave da empresa"
              value={infoPicKnGo.client_secret}
              onChange={(e) => setInfoPicKnGo({ ...infoPicKnGo, client_secret: e.target.value })}
            />
            <FaCheck
              color="white"
              style={{
                cursor: 'pointer',
                backgroundColor: '#C8131B',
                padding: 12,
                borderRadius: 8,
                width: 55,
                height: 40,
              }}
              onClick={handlePicKnGoAdd}
            />
          </InputsArea>
        }
      </CheckBoxArea>

      <CheckBoxArea>
        <DefaultInput
          placeholder="Token Neemo"
          value={restaurantData ?.settings.neemo_token}
          onChange={(e) => setRestaurantData((prevData) => ({
            ...prevData,
            settings: {
              ...prevData.settings,
              neemo_token: e.target.value,
            }
          }))}
        />
        <Checkbox
          label="Aceite Automático Neemo"
          checked={restaurantData ?.settings.neemo_auto_accept}
          onClick={(e) => setRestaurantData((prevData) => ({
            ...prevData,
            settings: {
              ...prevData.settings,
              neemo_auto_accept: e,
            },
          }))}
        />
      </CheckBoxArea>


      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>
          Estoque
                </span>
        <Checkbox
          label="Utilizar controle de estoque"
          checked={restaurantData ?.use_stock}
          onClick={(e) => handleChange('use_stock', e)}
        />
        <Checkbox
          label="Habilitar precificação"
          checked={restaurantData ?.settings.is_markup_allowed}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                is_markup_allowed: e,
              },
            }))
          }}
        />
      </CheckBoxArea>
      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Usa Pinpad / TEF presencial</span>
        <Checkbox
          label="Usa Pinpad / TEF presencial"
          checked={restaurantData ?.settings.use_pinpad}
          onClick={() => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["use_pinpad"]: !prevData.settings.use_pinpad,
              }
            }))
          }}
        />
      </CheckBoxArea>
      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>PIX no pinpad (PDV)</span>
        <Checkbox
          label="PIX no pinpad (PDV)"
          checked={restaurantData ?.settings.pinpad_pix_pdv_enabled}
          onClick={() => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["pinpad_pix_pdv_enabled"]: !prevData.settings.pinpad_pix_pdv_enabled,
              }
            }))
          }}
        />
      </CheckBoxArea>
      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>PIX no pinpad (Totem)</span>
        <Checkbox
          label="PIX no pinpad (Totem)"
          checked={restaurantData ?.settings.pinpad_pix_totem_enabled}
          onClick={() => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["pinpad_pix_totem_enabled"]: !prevData.settings.pinpad_pix_totem_enabled,
              }
            }))
          }}
        />
      </CheckBoxArea>
      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Vale refeição no pinpad (Totem)</span>
        <Checkbox
          label="Vale refeição no pinpad (Totem)"
          checked={restaurantData ?.settings.pinpad_voucher_totem_enabled}
          onClick={() => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["pinpad_voucher_totem_enabled"]: !prevData.settings.pinpad_voucher_totem_enabled,
              }
            }))
          }}
        />
      </CheckBoxArea>
      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Totem</span>
        <Checkbox
          label="Totem"
          checked={restaurantData ?.settings.use_totem}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["use_totem"]: e,
              }
            }))
          }}
        />
      </CheckBoxArea>

      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Mesas</span>
        <InputsArea>
          <DefaultSelect
            name="table_limit_type"
            options={tableOptions}
            label="Limitar mesas"
            value={tableLimitTypeDefault}
            onChange={(e) => {
              setTableLimitType(e.value);
              e.value === "limited-tables"
                ? setIsTableLimitDisabled(false)
                : setIsTableLimitDisabled(true);
              setTableLimitTypeDefault(e);
            }}
            controlStyles={{ height: 48 }}
          />

          <DefaultInput
            title="Limitar mesas"
            disabled={isTableLimitDisabled}
            value={tableLimitValue}
            type="number"
            onChange={(e) =>
              setTableLimitValue(e.target.value)
            }
          />
        </InputsArea>
      </CheckBoxArea>

      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Automação do WhatsApp</span>
        <Checkbox
          label="Habilitar automação de WhatsApp"
          checked={restaurantData ?.use_wpp}
          onClick={(e) => handleChange('use_wpp', e)}
        />
      </CheckBoxArea>

      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Conciliação bancária</span>
        <Checkbox
          label="Habilitar conciliação bancária"
          checked={restaurantData ?.settings.use_bank_reconciliation}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["use_bank_reconciliation"]: e,
              }
            }))
          }}
        />
      </CheckBoxArea>

      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Balança</span>

        <Checkbox
          label="Habilitar balança"
          checked={restaurantData ?.settings.use_balance}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["use_balance"]: e,
              }
            }))
          }}
        />
      </CheckBoxArea>


      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Smart POS</span>
        <Checkbox
          label="Utilizar smart POS"
          checked={restaurantData ?.settings.use_smart_pos}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["use_smart_pos"]: e,
              }
            }))
          }}
        />

        {(restaurantData ?.settings ?.use_smart_pos || posTableActive) &&
          <SwitchArea>
            <ToggleButton
              value={posTableActive}
              onClick={!loadingPosTableActive && handleChangePosTable}
              height=""
              disabled={loadingPosTableActive}
            />
            <p>Mesa Ficha</p>
          </SwitchArea>
        }
      </CheckBoxArea>

      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Tablet</span>
        <Checkbox
          label="Utiliza tablet"
          checked={restaurantData ?.settings.use_tablet}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["use_tablet"]: e,
              }
            }))
          }}
        />
        {/* <DefaultInput */}
        {/*     title="Limite de tablets" */}
        {/*     disabled={restaurantData?.settings.use_tablet} */}
        {/* // value={tableLimitValue} */}
        {/* // type="number" */}
        {/* // onChange={(e) => */}
        {/* //     setTableLimitValue(e.target.value) */}
        {/* // } */}
        {/* /> */}
      </CheckBoxArea>

      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Drive-Thru</span>
        <Checkbox
          label="Usa Drive-Thru"
          checked={restaurantData ?.settings.has_drive_thru}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["has_drive_thru"]: e,
              }
            }))
          }}
        />
      </CheckBoxArea>

      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>App de despacho</span>
        <Checkbox
          label="Usa app de despacho"
          checked={restaurantData ?.settings.use_dispatch_app}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["use_dispatch_app"]: e,
              }
            }))
          }}
        />
      </CheckBoxArea>

      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Etiquetas de manipulados</span>
        <Checkbox
          label="Usa etiquetas de manipulados"
          checked={restaurantData ?.settings.use_labels}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                ["use_labels"]: e,
              }
            }))
          }}
        />
      </CheckBoxArea>

      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>Aviso de pagamento</span>
        <Checkbox
          label="Ativar aviso de pagamento"
          checked={restaurantData ?.suspension_alert}
          onClick={(e) => handleChange('suspension_alert', e)}
        />
      </CheckBoxArea>
      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>
          F360
                </span>
        <Checkbox
          label="Ativar F360"
          checked={restaurantData ?.settings.has_f360}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                has_f360: e,
                f360_webhook: null,
                f360_token: null,
              }
            }))
          }}
        />

        {restaurantData ?.settings.has_f360 &&
          <InputsArea>
            <DefaultInput
              title="F360 Webhook URL"
              value={restaurantData ?.settings.f360_webhook}
              onChange={(e) =>
                setRestaurantData((prevData) => ({
                  ...prevData,
                  settings: {
                    ...prevData.settings,
                    f360_webhook: e.target.value,
                  }
                }))
              }
            />

            <DefaultInput
              title="F360 Chave/Token"
              value={restaurantData ?.settings.f360_token}
              onChange={(e) =>
                setRestaurantData((prevData) => ({
                  ...prevData,
                  settings: {
                    ...prevData.settings,
                    f360_token: e.target.value,
                  }
                }))
              }
            />
          </InputsArea>
                }
      </CheckBoxArea>
      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>
          MultiLinks
        </span>
        <Checkbox
          label="Habilitar MultiLinks"
          checked={restaurantData ?.settings.use_multilinks}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                use_multilinks: e,
              }
            }))
          }}
        />
      </CheckBoxArea>
      <CheckBoxArea>
        <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>
          Reservas
        </span>
        <Checkbox
          label="Habilitar Reservas"
          checked={restaurantData ?.settings.use_reservations}
          onClick={(e) => {
            setRestaurantData((prevData) => ({
              ...prevData,
              settings: {
                ...prevData.settings,
                use_reservations: e,
              }
            }))
          }}
        />
      </CheckBoxArea>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          title='Atualizar'
          buttonColor="#2EC9B7"
          onClick={() => updateProfile(restaurantData)}
        />
      </div>
    </Content >
  );
}

export default EditPayments;
